import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {environment} from '@env/environment';
import {
    SystemNotificationsSettingModel,
    OrganizationNotificationsSettingModel,
    UserNotificationsSettingModel
} from '../model/email-notifications.model';


@Injectable()

export class EmailNotificationsService {

    constructor(
        private http: HttpClient) {
    }

    getSystemNotificationsSetting(): Observable<SystemNotificationsSettingModel[]> {
        const url = `${environment.datahubBaseURI}/api/v2/notifications/settings`;

        return this.http
            .get<SystemNotificationsSettingModel[]>(url)
            .pipe(catchError(this.handleError));
    }


    getSystemMFASetting(): Observable<SystemNotificationsSettingModel> {
        const url = `${environment.datahubBaseURI}/mfa/instance`;

        return this.http
            .get<SystemNotificationsSettingModel>(url)
            .pipe(catchError(this.handleError));
    }

    getOrganizationNotificationsSetting(organizationGuid: string): Observable<OrganizationNotificationsSettingModel[]> {
        const url = `${environment.datahubBaseURI}/api/v2/notifications/settings/organizations/${organizationGuid}`;

        return this.http
            .get<OrganizationNotificationsSettingModel[]>(url)
            .pipe(catchError(this.handleError));
    }

    getUserNotificationsSetting(userGuid: string): Observable<UserNotificationsSettingModel> {
        const url = `${environment.datahubBaseURI}/api/v2/notifications/settings/users/${userGuid}`;

        return this.http
            .get<UserNotificationsSettingModel>(url)
            .pipe(catchError(this.handleError));
    }

    setSystemNotificationsSetting(settings: SystemNotificationsSettingModel[]): Observable<SystemNotificationsSettingModel[]> {
        const url = `${environment.datahubBaseURI}/api/v2/notifications/settings`;

        return this.http
            .put<SystemNotificationsSettingModel[]>(url, settings)
            .pipe(catchError(this.handleError));
    }

    setSystemMFASetting(settings: SystemNotificationsSettingModel): Observable<SystemNotificationsSettingModel> {
        const url = `${environment.datahubBaseURI}/mfa/instance`;

        return this.http
            .post<SystemNotificationsSettingModel>(url, settings)
            .pipe(catchError(this.handleError));
    }

    setOrganizationNotificationsSetting(settings: OrganizationNotificationsSettingModel[], organizationGuid: string): Observable<OrganizationNotificationsSettingModel[]> {
        const url = `${environment.datahubBaseURI}/api/v2/notifications/settings/organizations/${organizationGuid}`;

        return this.http
            .put<OrganizationNotificationsSettingModel[]>(url, settings)
            .pipe(catchError(this.handleError));
    }

    setUserNotificationsSetting(settings: UserNotificationsSettingModel): Observable<UserNotificationsSettingModel> {
        const url = `${environment.datahubBaseURI}/api/v2/notifications/settings/users/${settings.userGuid}`;

        return this.http
            .put<UserNotificationsSettingModel>(url, settings)
            .pipe(catchError(this.handleError));
    }

    setDefaultUserNotificationsSetting(userGuid: string): Observable<UserNotificationsSettingModel> {
        const url = `${environment.datahubBaseURI}/api/v2/notifications/settings/users/${userGuid}/default`;

        return this.http
            .post<UserNotificationsSettingModel>(url, null)
            .pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        } else {
            console.error(
                `Backend returned ${error.status}, ${error.error}`);
        }
        return throwError(
            'Something bad happened, please try again later.');
    }
}
